/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Hero_Title_CoachInputs */

const en_blog_hero_title_coach = /** @type {(inputs: Blog_Hero_Title_CoachInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coach better. Grow on purpose.`)
};

const pl_blog_hero_title_coach = /** @type {(inputs: Blog_Hero_Title_CoachInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prowadź lepiej. Rośnij świadomie.`)
};

/**
* | output |
* | --- |
* | "Coach better. Grow on purpose." |
*
* @param {Blog_Hero_Title_CoachInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const blog_hero_title_coach = /** @type {((inputs?: Blog_Hero_Title_CoachInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Hero_Title_CoachInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_blog_hero_title_coach(inputs)
	return en_blog_hero_title_coach(inputs)
});